import axios from "axios";
import { checkIfStoreIsOpen } from "./CheckIfStoreIsOpen";
import { checkIfStoreDeliveryIsOpen } from "./CheckIfStoreDeliveryIsOpen";
import { BASE_API, APPLICATION, setStore } from "../../constants";

export const fetchStoreData = async ({
  appContext,
  setAppContext,
  setStoreContext,
  setApplicationNotFound,
  setDetailsAreLoading,
  setMenuName,
  setCategoryName,
  setSubCategoryName,
  setDiscountEndDate,
}) => {
  try {
    const response = await axios.get(`${BASE_API}api/Store/GetStore/${APPLICATION}`, {
      headers: {
        Application: APPLICATION,
      },
    });

    const { store, storeHours, deliveryHours, storeClosures, orderETAs } = response.data;

    const isOpen = checkIfStoreIsOpen(storeHours, storeClosures);
    const isDeliveryOpen = checkIfStoreDeliveryIsOpen(deliveryHours, storeClosures);

    const pickupETA = `${orderETAs[0].pickupMin} - ${orderETAs[0].pickupMax} minutes`;
    const deliveryETA = `${orderETAs[0].deliveryMin} - ${orderETAs[0].deliveryMax} minutes`;

    const newStoreContext = {
      open: isOpen,
      deliveryOpen: isDeliveryOpen,
      storeID: store[0].storeID,
      name: store[0].name,
      nameCode: store[0].nameCode,
      taxPercentage: store[0].taxPercentage,
      chargePercent: store[0].discountChargePercent,
      discountPercent: store[0].discountPercent,
      hours: storeHours,
      deliveryHours: deliveryHours,
      deliveryETA,
      pickupETA,
      address: store[0].address,
      phoneNumber: store[0].phoneNumber,
      categoryName: store[0].categoryName,
      subCategoryName: store[0].subCategoryName,
      mxMerchant: store[0].mxMerchant,
      isActive: store[0].isActive,
      acceptDelivery: store[0].acceptDelivery,
      color: store[0].color,
      deliveryFee: store[0].deliveryFee,
      deliveryMiles: store[0].deliveryMiles,
      deliveryMin: store[0].deliveryMin,
      orderMin: store[0].orderMin,
      isCashAdjustment: store[0].isCashAdjustment,
      orderFee: store[0].orderFee,
      seoKeywords: store[0].seoKeywords,
      seoDescription: store[0].seoDescription,
      seoLink: store[0].seoLink,
      seoImage: store[0].seoImage,
      payLater: store[0].payLater,
      rewardsProgram: store[0].rewardsProgram,
      tzOffset: store[0].tzOffset,
      storeClosures,
    };

    ////////////////////////////////////
    //Manifest Code 
    const manifest = {
      short_name: store[0].name,
      name: `${store[0].name} | Online Ordering`,
      start_url: `/${store[0].nameCode}`,
      scope: `/${store[0].nameCode}/`,
      display: "standalone",
      theme_color: `${store[0].color}`,
      background_color: "#FFFFFF",
      orientation: "portrait-primary",
      icons: [
        {
          src: "/favicon.ico",
          sizes: "64x64 32x32 24x24 16x16",
          type: "image/x-icon"
        },
        {
          src: "/logo192.png",
          type: "image/png",
          sizes: "192x192"
        },
        {
          src: "/logo512.png",
          type: "image/png",
          sizes: "512x512"
        }
      ],
      lang: "en"
    };
    const manifestBlob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
    const manifestURL = URL.createObjectURL(manifestBlob);
    // Remove old manifest if it exists
    const existingManifest = document.querySelector('link[rel="manifest"]');
    if (existingManifest) {
      document.head.removeChild(existingManifest);
      URL.revokeObjectURL(existingManifest.href);
    }
    // Inject the new manifest
    const manifestLink = document.createElement('link');
    manifestLink.rel = 'manifest';
    manifestLink.href = manifestURL;
    document.head.appendChild(manifestLink);
    ////////////////////////////////////

    setMenuName(store[0].menuName);
    setCategoryName(store[0].categoryName);
    if (store[0].subCategoryName) {
      setSubCategoryName(store[0].subCategoryName);
    }
    setDiscountEndDate(store[0].discountEndDate);
    setStoreContext(newStoreContext);
    localStorage.setItem("storeContext", JSON.stringify(newStoreContext));

    if (appContext.userInfo && newStoreContext.nameCode !== appContext.userInfo.storeName) {
      const newAppContext = { userInfo: null, cart: null, cartItems: null };
      setAppContext(newAppContext);
      localStorage.setItem("appContext", JSON.stringify(newAppContext));
    }

    if (newStoreContext.color) {
      const element2 = document.getElementById("cart_screen");
      if (element2) {
        element2.style.backgroundColor = newStoreContext.color;
      }
    }

    setStore(
      newStoreContext.orderFee,
      newStoreContext.hours,
      newStoreContext.open,
      newStoreContext.name,
      newStoreContext.nameCode,
      newStoreContext.taxPercentage,
      newStoreContext.discountPercent,
      newStoreContext.categoryName,
      newStoreContext.subCategoryName
    );

    setApplicationNotFound(false);
    setDetailsAreLoading(false);
  } catch (error) {
    setApplicationNotFound(true);
    setStoreContext({});
    localStorage.setItem("storeContext", JSON.stringify({}));
  }
};
